import { formatDateStringToDate } from './formatDateStringToDate'

export const sortDates = (dateStrings: string[]) => {
  return dateStrings.sort(
    (a, b) =>
      formatDateStringToDate(a).getTime() - formatDateStringToDate(b).getTime()
  )
}
